export const CardPaymentV2Icon = ({ width = 46 }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* White circular background */}
      <circle cx="23" cy="23" r="23" fill="white" />

      <rect x="0.5" y="0.5" width="45" height="45" rx="22.5" stroke="#916CF1" />
      <path
        d="M13.375 13.375L13.375 32.625C13.375 34.1438 14.6062 35.375 16.125 35.375L29.875 35.375C31.3938 35.375 32.625 34.1438 32.625 32.625L32.625 13.375C32.625 11.8562 31.3938 10.625 29.875 10.625L16.125 10.625C14.6062 10.625 13.375 11.8562 13.375 13.375Z"
        fill="white"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3125 21.181C21.8846 21.6658 21.625 22.3026 21.625 23C21.625 24.5188 22.8562 25.75 24.375 25.75C25.8938 25.75 27.125 24.5188 27.125 23C27.125 22.3026 26.8654 21.6658 26.4375 21.181"
        stroke="#FD561F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.125 18.874C27.125 17.3552 25.8938 16.124 24.375 16.124C22.8562 16.124 21.625 17.3552 21.625 18.874C21.625 20.3928 22.8562 21.624 24.375 21.624C25.8938 21.624 27.125 20.3928 27.125 18.874Z"
        stroke="#F7AD3C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
